<div class="broadcast-console" [class.broadcast-console--modal]="isModal">

  <div class="broadcast-header">
    <div class="broadcast-header__text">
      <span class="broadcast-eyebrow">Broadcast console</span>
      <h4 class="broadcast-title">New broadcast</h4>
    </div>
    <div class="broadcast-header__meta">
      <span class="broadcast-status" [class.broadcast-status--sending]="sending">
        <span class="broadcast-status__dot" aria-hidden="true"></span>
        {{ sending ? 'Sending…' : 'Ready' }}
      </span>
      <button *ngIf="isModal" type="button" class="btn btn-light btn-icon-round" (click)="close()" aria-label="Close">
        <i class="feather icon-x"></i>
      </button>
    </div>
  </div>

  <div class="alert alert-success py-2 mb-2" *ngIf="broadcastSucceeded">
    <ng-container *ngIf="sentCount; else broadcastOk">
      Message delivered to <strong>{{ sentCount }}</strong> users.
    </ng-container>
    <ng-template #broadcastOk>
      Broadcast sent successfully.
      <!-- <span *ngIf="receiptsQueued && deliveryMode">
        ({{ deliveryMode === 'audience_query' ? 'large audience — live + inbox on read' : 'receipts queued' }})
      </span>
      <span *ngIf="!receiptsQueued && deliveryMode">
        ({{ deliveryMode === 'audience_query' ? 'large audience — live + inbox on read' : deliveryMode }})
      </span>. -->
    </ng-template>
  </div>

  <form [formGroup]="form" (ngSubmit)="sendNow()">
    <div class="broadcast-grid">

      <!-- Left: compose -->
      <div class="broadcast-panel broadcast-panel--compose">
        <div class="form-group">
          <div class="field-header">
            <label class="control-label mb-0" for="broadcast-title">Title</label>
            <span id="broadcast-title-counter" class="char-counter"
              [class.char-counter--limit]="titleLength >= TITLE_MAX" aria-live="polite">
              {{ titleLength }}/{{ TITLE_MAX }}
            </span>
          </div>
          <input id="broadcast-title" class="form-control" formControlName="title"
            placeholder="Message title" [maxlength]="TITLE_MAX" aria-describedby="broadcast-title-counter" />
          <!-- <ngb-alert [dismissible]="false" type="danger" class="mt-2 mb-0 py-2"
            *ngIf="form.get('title')?.errors?.required && (form.get('title')?.dirty || form.get('title')?.touched)">
            Title is required.
          </ngb-alert> -->
          <ngb-alert [dismissible]="false" type="danger" class="mt-2 mb-0 py-2"
            *ngIf="form.get('title')?.errors?.maxlength && (form.get('title')?.dirty || form.get('title')?.touched)">
            Title cannot exceed {{ TITLE_MAX }} characters.
          </ngb-alert>
        </div>

        <div class="form-group">
          <div class="field-header">
            <label class="control-label mb-0" for="broadcast-body">Message</label>
            <span id="broadcast-body-counter" class="char-counter"
              [class.char-counter--limit]="bodyLength >= BODY_MAX" aria-live="polite">
              {{ bodyLength }}/{{ BODY_MAX }}
            </span>
          </div>
          <textarea id="broadcast-body" class="form-control broadcast-message" rows="4"
            formControlName="body" placeholder="Write your message..." [maxlength]="BODY_MAX"
            aria-describedby="broadcast-body-counter"></textarea>
          <!-- <ngb-alert [dismissible]="false" type="danger" class="mt-2 mb-0 py-2"
            *ngIf="form.get('body')?.errors?.required && (form.get('body')?.dirty || form.get('body')?.touched)">
            Message is required.
          </ngb-alert> -->
          <ngb-alert [dismissible]="false" type="danger" class="mt-2 mb-0 py-2"
            *ngIf="form.get('body')?.errors?.maxlength && (form.get('body')?.dirty || form.get('body')?.touched)">
            Message cannot exceed {{ BODY_MAX }} characters.
          </ngb-alert>
        </div>

        <div class="form-group mb-0">
          <label class="control-label">Category</label>
          <ng-select
            [items]="categories"
            bindLabel="label"
            bindValue="value"
            formControlName="category"
            placeholder="Select category"
            [clearable]="false"
            dropdownPosition="auto">
          </ng-select>
        </div>
      </div>

      <!-- Right: audience + attachment + send -->
      <div class="broadcast-panel broadcast-panel--side">
        <h5 class="broadcast-panel__heading">Send to</h5>

        <div class="audience-grid" role="group" aria-label="Audience type">
          <button type="button" class="audience-tile"
            *ngFor="let opt of audienceTypes"
            [class.active]="audienceType === opt.value"
            (click)="selectAudienceType(opt.value)">
            <i class="feather" [ngClass]="opt.icon"></i>
            <span>{{ opt.label }}</span>
          </button>
        </div>

        <!-- User type multi-select -->
        <div class="form-group audience-field mt-2 mb-0" *ngIf="audienceType === 'role'">
          <label class="control-label">Select user types</label>
          <ng-select
            [items]="roleOptions"
            bindLabel="displayName"
            bindValue="name"
            [closeOnSelect]="false"
            [multiple]="true"
            placeholder="User type"
            clearAllText="Clear"
            formControlName="targetValues"
            [clearSearchOnAdd]="true">
          </ng-select>
        </div>

        <!-- Email multi-select with typeahead -->
        <div class="form-group audience-field mt-2 mb-0" *ngIf="audienceType === 'email'">
          <label class="control-label">Select user emails</label>
          <ng-select
            [ngClass]="'tpn_label'"
            [items]="userEmailsList | async"
            bindValue="email"
            bindLabel="email"
            formControlName="targetValues"
            [loading]="userSearching"
            notFoundText="No Users found"
            [clearSearchOnAdd]="false"
            [hideSelected]="true"
            [closeOnSelect]="false"
            [multiple]="true"
            [virtualScroll]="true"
            placeholder="Type to search emails..."
            clearAllText="Clear"
            typeToSearchText="Please enter 4 or more characters"
            [typeahead]="inputUserEmail$">
          </ng-select>
        </div>

        <!-- TPN multi-select with typeahead -->
        <div class="form-group audience-field mt-2 mb-0" *ngIf="audienceType === 'tpn'">
          <label class="control-label">Select TPN numbers</label>
          <ng-select
            [items]="tpns$ | async"
            bindLabel="tpn"
            bindValue="tpn"
            formControlName="targetValues"
            [loading]="tpnsLoading"
            notFoundText="No TPN numbers found"
            [clearSearchOnAdd]="false"
            [hideSelected]="true"
            [closeOnSelect]="false"
            [multiple]="true"
            [virtualScroll]="true"
            placeholder="Type to search TPN numbers..."
            clearAllText="Clear"
            typeToSearchText="Please enter 2 or more characters"
            [typeahead]="tpnInput$">
          </ng-select>
          <small class="text-muted d-block mt-1">Recipients include merchant owners linked to selected TPNs.</small>
        </div>

        <div class="alert alert-warning py-2 mb-0 mt-2"
          *ngIf="audienceType && audienceType !== 'everyone' && !hasAudienceSelection()">
          <i class="feather icon-alert-triangle mr-1"></i>
          Select at least one {{ audienceType === 'role' ? 'user type' : audienceType === 'email' ? 'email' : 'TPN' }}.
        </div>

        <div class="form-group attachment-field mt-3 mb-0">
          <label class="control-label">Attachment <span class="text-muted">(optional)</span></label>

          <label class="attachment-dropzone" *ngIf="!attachment" [class.attachment-dropzone--busy]="uploading">
            <i class="feather" [ngClass]="uploading ? 'icon-loader spin' : 'icon-upload-cloud'"></i>
            <span *ngIf="!uploading">
              Drop a file or <strong>browse</strong>
              <span class="attachment-dropzone__hint"> · PDF, JPG, PNG, GIF, XLS, XLSX up to 10MB</span>
            </span>
            <span *ngIf="uploading">Uploading...</span>
            <input type="file" class="d-none"
              accept=".pdf,.jpg,.jpeg,.png,.gif,.xls,.xlsx,image/*,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              (change)="onFileSelected($event)" [disabled]="uploading" />
          </label>

          <div class="attachment-chip" *ngIf="attachment">
            <i class="feather icon-file-text" aria-hidden="true"></i>
            <span class="attachment-chip__name">{{ attachment.fileName }}</span>
            <button type="button" class="attachment-chip__remove" (click)="removeAttachment()">Remove</button>
          </div>
        </div>

        <div class="broadcast-actions">
          <span class="broadcast-actions__summary">
            <i class="feather icon-users"></i>
            {{ audienceSummary() }}
          </span>
          <button type="submit" class="btn btn-primary broadcast-actions__submit"
            [disabled]="form.invalid || sending || uploading || !hasAudienceSelection()">
            <i class="feather icon-radio" *ngIf="!sending"></i>
            {{ sending ? 'Sending...' : 'Send broadcast' }}
          </button>
        </div>
      </div>

    </div>
  </form>
</div>
